import TextField from '@engined/client/components/forms/fields/TextField.js';
import { LocaleContextValue, useLocale } from '@engined/client/contexts/LocaleContext.js';
import { FORGOTTEN_PASSWORD_EMAIL, FORGOTTEN_PASSWORD_EMAIL_IS_REQUIRED } from '@asaprint/asap/locales/client.js';
import { FormErrors } from '@engined/client/hooks/useFormResolver.js';
import React from 'react';

export interface FormValues {
  usernameOrEmail: string;
}

export const initialValues: FormValues = {
  usernameOrEmail: '',
};

export function validate(values: FormValues, t: LocaleContextValue['t']) {
  const errors: FormErrors<FormValues> = {};
  if (!values.usernameOrEmail) {
    errors.usernameOrEmail = t(FORGOTTEN_PASSWORD_EMAIL_IS_REQUIRED);
  }

  return errors;
}

interface Props {
  className?: string;
}

const ForgottenPasswordForm: React.FunctionComponent<Props> = ({ className }) => {
  const { t } = useLocale();

  return (
    <div className={className}>
      <TextField
        margin="normal"
        variant="standard"
        required
        fullWidth
        label={t(FORGOTTEN_PASSWORD_EMAIL)}
        name="usernameOrEmail"
        autoComplete="email"
        autoFocus
      />
    </div>
  );
};

ForgottenPasswordForm.displayName = 'ForgottenPasswordForm';

export default React.memo<Props>(ForgottenPasswordForm);
